import type { ComponentProps } from "react"
import ViewSheet from "@/v2-backoffice-client/components/viewSheet"
import { TooltipLink } from "@/v2-backoffice-client/components/link"
import { FEATURE_TYPE_CODE } from "@/v2-backoffice-client/feature/feature.constants"
import type { LicenseContentItem } from "@/v2-backoffice-client/license/changes/license.content.utils"

export type LicenseContentViewToolbarProps = ComponentProps<"div"> & {
  item: LicenseContentItem | null | undefined
}

// The item itself (its text, configuration, countries, publish state) is
// edited on its own sheet, keyed by the same feature code; this panel only
// decides who has it. The link pushes that sheet onto the panel's trail.
function LicenseContentViewToolbar(props: LicenseContentViewToolbarProps) {
  const { item, ...viewSheetToolbarProps } = props
  if (!item) return null

  const isBasemap = item.FeatureTypeCode === FEATURE_TYPE_CODE.basemap

  return (
    <ViewSheet.Toolbar {...viewSheetToolbarProps}>
      <TooltipLink
        variant="ghost"
        isStacked
        iconSrc={isBasemap ? "map" : "layers"}
        content={
          isBasemap
            ? "Open the base map's own sheet: its text, configuration, countries and publish state live there"
            : "Open the layer's own sheet: its text, configuration, countries and publish state live there"
        }
        to={`>>?v=${isBasemap ? "basemap" : "layer"}:${item.Code}`}
        data-feature-code="UI_BackofficeWhatsNewContent_Panel_OpenItem"
      >
        {isBasemap ? "Base map" : "Layer"}
      </TooltipLink>
    </ViewSheet.Toolbar>
  )
}

export default LicenseContentViewToolbar
